import React from "react";
import { useSelector } from "react-redux";
import { formatDateReadable } from "../../helpers/dateTimeHelpers";
import LoadingSpinner from "../animations/LoadingSpinner";

const ComplianceList = ({ items = [], isLoading = false, type = "doctor" }) => {
  const user = useSelector((state) => state.userReducer.user);
  const isDoctor = type === "doctor";

  // Show loading state if data is being fetched
  if (isLoading) {
    return (
      <div className="space-y-6 flex justify-center items-center min-h-[200px]">
        <div className="text-center">
          <LoadingSpinner size="lg" className="mb-4" />
          <p className="text-muted-foreground">
            Loading {isDoctor ? "doctor notes" : "patient logs"}...
          </p>
        </div>
      </div>
    );
  }

  // Show empty state if no items
  if (items.length === 0) {
    return (
      <div className="space-y-6">
        <div className="w-full p-4 border-solid border-[1px] border-[#E7E8E9] rounded-lg text-center">
          <p className="font-[500] text-[#666970] text-[16px]">
            No {isDoctor ? "doctor notes" : "patient logs"} available yet. Click
            the add button to create your first entry.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {items.map((item) => {
        const formattedDate = formatDateReadable(item.createdAt || item.date);
        const formattedTime =
          item.time ||
          new Date(
            item.createdAt || item.date || new Date(),
          ).toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });

        return (
          <div
            key={item.id}
            className="w-full p-4 border-solid border-[1px] border-[#E7E8E9] rounded-lg"
          >
            <div className="flex items-center justify-between mb-2">
              <h6 className="font-semibold text-gray-700 text-sm">
                {formattedDate} {formattedTime}
              </h6>
            </div>
            <p className="font-[500] text-[#666970] text-[16px]">
              {item.log || item.notes}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default ComplianceList;
